module.exports = __webpack_public_path__ + "img/typing_title.e2aeef08.png";